import { useDesigns } from '@customink/project-service-react-components';

export const useFirstDesignCid = () => {
  const designsById = useDesigns();
  const designs = Object.values(designsById);
  return designs[0]?.compositeId;
};
